import type { IconProps } from './icon.types'

const GlobeIcon = (props: IconProps) => (
  <svg
    width='14'
    height='14'
    viewBox='0 0 18 18'
    fill='none'
    stroke='currentColor'
    strokeWidth='1'
    strokeLinecap='round'
    strokeLinejoin='round'
    aria-hidden='true'
    data-testid='globe-icon'
    {...props}
  >
    <circle cx='9' cy='9' r='6.5' />
    <path d='M2.5 9h13M9 2.5c1.8 2 2.7 4.3 2.7 6.5S10.8 13.5 9 15.5C7.2 13.5 6.3 11.2 6.3 9S7.2 4.5 9 2.5z' />
  </svg>
)

export default GlobeIcon
